import { useOutletContext } from 'react-router-dom'

import { useStableValue } from '../../../common/hooks'
import type { Tag } from '../../../common/types/common'
import TimeActivities from '../TimeLayout/TimeActivities'
import TimeStats from './TimeStats'

const Time = () => {
  const { tagFilters } = useOutletContext<{
    tagFilters: Tag[]
    appName: string
    contentName: string
    label: string
  }>()

  // Stabilize objects to prevent unnecessary re-renders
  const stableQueryOptions = useStableValue({
    tagsOfInterestSource: 'window' as const,
    tagFilters,
    use_exact_tag_filter_match: true,
  })

  return (
    <div className='flex flex-col gap-3'>
      <TimeStats />

      <TimeActivities queryOptions={stableQueryOptions} />
    </div>
  )
}

export default Time

